/**
 * Retourne une plage d'entier sous forme d'un tableau.
 * @param length Taille de la plage attendue
 * @param startFrom Premier élément de la plage, par exemple pour avoir une plage de 5-7, `length = 3, startFrom = 5`
 * @example
 * // une plage de 0 à 10
 * const from0To10 = arrayRange(11);
 * // une plage de 1 à 10
 * const from0To10 = arrayRange(10, 1);
 * // une plage de 10 à 15
 * const from10to15 = arrayRange(6, 10);
 */
function arrayRange(length: number, startFrom: number = 0): Array<number> {
  return Array.from({ length }, (_, i) => startFrom + i);
}

export const rangeUtil = {
  arrayRange,
};
